import {Dialog} from '@ui/overlays/dialog/dialog';
import {DialogHeader} from '@ui/overlays/dialog/dialog-header';
import {DialogBody} from '@ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {Trans} from '@ui/i18n/trans';
import {Button} from '@ui/buttons/button';
import {DialogFooter} from '@ui/overlays/dialog/dialog-footer';
import {useReleaseLicense} from './requests/use-release-license';

const ThemeColor = {
  cadetColor: "#1e90ff",
  nobleColor: "#009e60",
  regalColor: "#9238d3",
  royalColor: "#dc143c",
  eliteColor: "#A16750",
};

const PackageBadge = ({id, active = 1, forcom = false}: {id: number, active?: number, forcom?: boolean}) => {
  if (id == 1) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.cadetColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Basic
        </span>
      </span>
    );
  }
  if (id == 2) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.nobleColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Standard
        </span>
      </span>
    );
  }
  if (id == 3) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.regalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Ultra
        </span>
      </span>
    );
  }
  if (id == 4) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.royalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Premium
        </span>
      </span>
    );
  }

  if (id == 5) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.nobleColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Standard
        </span>
      </span>
    );
  }
  if (id == 6) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.royalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Premium
        </span>
      </span>
    );
  }
  if (id == 9) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: active == 1 ? ThemeColor.eliteColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Elite
        </span>
      </span>
    );
  }
  if (id == 0) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: '#a8a8a8',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Free
        </span>
      </span>
    );
  }
  return null;
};

interface ReleaseLicenseDialogProps {
  license: any;
}

export function ReleaseLicenseDialog({license}: ReleaseLicenseDialogProps) {
  const {close} = useDialogContext();
  const releaseLicense = useReleaseLicense();

  const handleRelease = () => {
    releaseLicense.mutate(
      {id: license.id},
      {
        onSuccess: () => {
          close();
        },
      },
    );
  };

  return (
    <Dialog size="md">
      <DialogHeader>
        <Trans message="Release License" />
      </DialogHeader>
      <DialogBody>
        <div className="space-y-16">
          <div className="flex justify-between gap-12 p-12 bg-alt rounded">
            <div>
              <div className="text-xs text-muted mb-4">
                <Trans message="Package" />
              </div>
              <div className="text-sm font-medium">
                <PackageBadge id={license.package_id} active={1} forcom={false} />
              </div>
            </div>
            <div className="text-right">
              <div className="text-xs text-muted mb-4">
                <Trans message="License Key" />
              </div>
              <div className="text-sm font-medium">{license.key}</div>
            </div>
          </div>

          <div className="flex justify-between gap-12 text-sm">
            <div>
              <div className="text-xs text-muted mb-4">
                <Trans message="Order ID" />
              </div>
              <div className="font-medium">#{license.id}</div>
            </div>
          </div>

          {license.active_data && (
            <div className="p-12 bg-danger/10 border border-danger rounded">
              <div className="font-medium mb-8">
                <Trans message="Currently Assigned To" />
              </div>
              <div className="space-y-6 text-sm">
                <div>
                  <Trans message="Name" />: {license.active_data.userinfo?.name}
                </div>
                <div>
                  <Trans message="Username" />:{' '}
                  {license.active_data.userinfo?.username}
                </div>
                <div>
                  <Trans message="Phone" />:{' '}
                  {license.active_data.userinfo?.phone}
                </div>
                <div>
                  <Trans message="Location" />:{' '}
                  {license.active_data.userinfo?.city},{' '}
                  {license.active_data.userinfo?.state},{' '}
                  {license.active_data.userinfo?.country}
                </div>
              </div>
            </div>
          )}

          <div className="text-sm text-muted">
            <Trans message="Are you sure you want to release this license? This action will remove the license from the assigned user." />
          </div>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button onClick={close} variant="outline">
          <Trans message="Cancel" />
        </Button>
        <Button
          onClick={handleRelease}
          variant="flat"
          color="danger"
          disabled={releaseLicense.isPending}
        >
          <Trans message="Release License" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
